const WorkflowRejectCodes = {
    0: 'Cannot Disable Wires API for Firm - Check Users and Accounts Permissions',
    1: 'Account, Firm, or Bank is not IBN-Enabled',
    2: 'Wallet Address is not IBN-Enabled or inactive',
    3: 'Recipient Wallet Address is invalid or unable to receive',
    4: 'Wallet Address is invalid or unable to send',
    5: 'Rejected by Network Server. Check logs for reject code',
    6: 'Invalid settlement ID',
    7: 'Invalid settlement modification request',
    8: 'Duplicate UUID',
    9: 'Wire API cannot be removed when user still has API connections',
    10: 'Transaction Limit Operation Failed',
    11: 'Transaction Limit Invalid',
    12: 'Credit Risk Limit Operation Failed',
    13: 'Credit Risk Limit Invalid',
    14: 'Credit Risk Limit Missing',
    15: 'Transaction Limit Invalid',
    16: 'Credit Risk Limit Operation Failed',
    17: 'Credit Risk Limit Invalid',
    18: 'Credit Risk Limit Missing',
    19: 'Liquidity Risk Limit Operation Failed',
    20: 'Transaction type not allowed for asset',
    32: 'Success',
    33: 'Missing Api Connection User',
    34: 'Firm Frozen',
    35: 'Missing Api Connection Firm',
    36: 'Not An API Firm',
    37: 'Missing Client ID',
    38: 'Close Delete Acct Has Balance',
    39: 'Close Delete Acct Has Live Transaction',
    40: 'Missing Audience',
    41: 'Account Has Live Transaction',
    42: 'Failed Firm Api Connection',
    43: 'Not An API User',
    44: 'Duplicate User Account',
    45: 'Duplicate Api User',
    46: 'Firm Closed',
    47: 'Invalid Address Book',
    48: 'Account Deleted',
    49: 'Firm Not Active',
    50: 'Firm Disabled',
    51: 'Firm Locked',
    52: 'Firm Deleted',
    53: 'PCG Mapped To Accounts',
    54: 'Account Disabled',
    55: 'Account Locked',
    56: 'Account Frozen',
    57: 'Account Closed',
    58: 'Duplicate Address Book',
    59: 'Missing PCGname',
    60: 'Invalid Status',
    61: 'Missing Api Connection Name',
    62: 'Invalid Time Window',
    63: 'PCGuser Is Not PCGAdmin',
    64: 'Failed User Api Connection',
    65: 'Missing Account',
    66: 'Duplicate Address',
    67: 'Duplicate Account',
    68: 'Duplicate Firm',
    69: 'Bad Firm',
    70: 'Missing Firm',
    71: 'Approver Invalid',
    72: 'Approver Is User',
    73: 'Approver Not In Firm',
    74: 'Already Approved',
    75: 'Missing Address Book',
    76: 'Missing PCG',
    77: 'Missing PCGuser',
    78: 'Missing Api Connection',
    79: 'Admin Operator Expired',
    80: 'Invalid User',
    81: 'User Disabled',
    82: 'User Locked',
    83: 'User Deleted',
    84: 'User Terms Missing',
    85: 'Missing User',
    86: 'Invalid User Role',
    87: 'Missing User Account',
    88: 'Missing Deposit',
    89: 'Missing Redeem',
    90: 'Invalid Wallet',
    91: 'PCGuser Max PCGs Exceeded',
    92: 'Blockchain Status Down',
    93: 'Delete User Has Live Transaction',
    94: 'Delete Firm Has Active Api Users',
    95: 'Missing Source ID',
    96: 'Close Delete Firm Has Active Accounts',
    97: 'Invalid Account',
    98: 'Duplicate PCGnumber',
    99: 'Failed Api Connection Operation',
    100: 'Invalid Firm Account Length',
    101: 'Failed Account Operation',
    102: 'Failed Wallet Operation',
    103: 'Failed Wallet Keys Creation',
    104: 'Failed Firm Operation',
    105: 'Failed User Operation',
    106: 'Invalid Amount',
    107: 'Bad Sender Account',
    108: 'Bad Recipient Account',
    109: 'Amount Greater Than Available',
    110: 'Failed Authentication Provider',
    111: 'Invalid Deposit Exception Command',
    112: 'Invalid Redeem Exception Command',
    113: 'Deposit Ack Exception',
    114: 'Redeem Ack Exception',
    115: 'Duplicate Nickname1',
    116: 'Failed Address Book Operation',
    117: 'Missing Requester',
    118: 'Failed PCG Operation',
    119: 'Failed PCGuser Operation',
    120: 'Failed User Account Operation',
    121: 'Missing PCGnumber',
    122: 'User Role Not Authorized',
    123: 'Delete Firm Has Active Users',
    124: 'Email is currently in use.  Please enter a unique email',
    125: 'Fisapi Req Rejected',
    126: 'Close Delete Firm Not Locked Or Not Frozen',
    127: 'ACH firm mnemonic is missing. Please provide firm mnemonic if firm is ACH enabled',
    128: 'Missing Account Name',
    129: 'ACH comp id is missing. Please provide ACH comp id if firm is ACH enabled',
    130: 'Duplicate wallet',
    131: 'FedWire Connectivity Error',
    132: 'FedWire Submit Reject',
    133: 'Firm does not have permission for FedWire',
    134: 'Account does not have permission for FedWire',
    135: 'Missing Wire Role',
    136: 'Invalid Wire Role',
    137: 'Missing Firm Wire Data',
    138: 'Failed Firm Wire Data Operation',
    139: 'Failed AbaBic Operation',
    140: 'Duplicate BbkSwiftCode',
    141: 'Missing AbaBic',
    142: 'Failed AbaFed Operation',
    143: 'Duplicate AbaFed',
    144: 'Missing AbaFed',
    145: 'Failed RecipientWireBlacklist Operation',
    146: 'Duplicate RecipientWireBlacklist',
    147: 'Missing RecipientWireBlacklist',
    148: 'Invalid BbkSwift Code Size',
    149: 'Invalid IbkSwift Code Size',
    150: 'Invalid Aba Number Size',
    151: 'Missing Account Wire Data',
    152: 'Failed Account Wire Data Operation',
    153: 'Cannot Disable Wires API for Firm - Check Users and Accounts Permissions',
    154: 'Missing Account Balance',
    155: 'Existing Scheduled Smart Contract Payments',
    156: 'Failed Smart Contract Payment Data Operation',
    157: 'Failed Smart Contract Payment Blockchain Operation',
    158: 'Invalid Date',
    159: 'Firm is not smart contract enabled',
    160: 'UserAccount is not smart contract enabled',
    161: 'UserAccount is  smart contract enabled',
    162: 'Contract name already exists',
    163: 'Internal Error Occurred',
    164: 'Duplicate contract',
    165: 'Bank API Operation Failed',
    166: 'Bank API Operation Rejected',
    167: 'User should be disabled for wires from any accounts',
    168: 'FedWire Low Balance',
    169: 'Invalid Company Code',
    170: 'Duplicate Company Code',
    171: 'Failed user validation operation',
    172: 'Invalid SSO User ID',
    173: 'Missing LEI',
    174: 'Liquidity facility has pending transactions',
    175: 'Invalid AccountType',
    176: 'Unable to delete account with linked wallets',
    177: 'Invalid LEI',
    178: 'Invalid Linked Account',
    179: 'Maximum Liquidity Facility wallets in firm already reached',
    180: 'Missing Email',
    181: 'Admin must be Operations Admin',
    182: 'Withdrawal instruction with this description already exists',
    183: 'Missing Account Withdrawal Relationship',
    184: 'Account Withdrawal Relationship Already exists',
    185: 'Cannot unset the primary wallet for an account',
    186: 'invalid asset type',
    187: 'Account not active ',
    188: 'invalid approval type',
    189: 'Invalid Fee',
    190: 'Invalid Quantity',
    191: 'Invalid Price',
    192: 'Linked Broker-Dealer Account Is Closed',
    193: 'Block chain exception',
    194: 'Insufficient Balance for transaction',
    195: 'Invalid or missing  purpose  ',
    196: 'Transfer not allowed for the firm and asset combination  ',
    197: 'Order side missing or Invalid',
    198: 'Missing Primary Account',
    199: 'Invalid Order Id',
    200: 'Invalid Linked Order Id',
    201: 'Missing Account Position',
    202: 'INVALID INTEREST SESSION',
    203: 'NO INTEREST RECORDS',
    204: 'Liquidity Facility Not Allowed To Initiate Buy/Sell',
    205: 'Order Status Invalid',
    206: 'LF Firm either inactive or not present',
    207: 'LF Firm either has inactive or not present account',
    208: 'Invalid Order',
    209: 'Invalid Transaction',
    210: 'AML Check Rejected',
    211: 'Transaction does not need another AML check at this time',
    212: 'No orders available for netting',
    213: 'Last netting not complete',
    214: 'Order cancel in progress',
    215: 'Missing Required Fields',
    216: 'Firm Not Active',
    217: 'Bad Response',
    218: 'Failed Withdrawal',
    219: 'Missing API Feature Name',
    220: 'Missing API Feature Value',
    221: 'Duplicate API Feature',
    222: 'Invalid Secondary Api Connection Type',
    223: 'Missing API Feature',
    224: 'Duplicate API Feature User',
    225: 'Invalid API Connection',
    226: 'Invalid Delete operation on Secondary Api Connection',
    227: 'Attribute Length is not valid',
    228: 'Invalid bank account number',
    229: 'Illegal characters in attribute',
    230: 'Invalid country code',
    231: 'Attribute must be empty',
    232: 'Webhook subscription already exists',
    233: 'Invalid webhook event type',
    234: 'Webhook subscription does not exist',
    235: 'Firm is not enabled for Collateral',
    236: 'Pledgee cannot be the same as Pledgor',
    237: 'Asset is not enabled for Collateral',
    238: 'Pledge not found',
    239: 'Pledge is not active',
    240: 'Requester is not authorized for this operation',
    241: 'Reclaim amount exceeds pledge amount',
    242: 'Amount below minimum of 0.01',
    243: 'Firm has active pledges',
    244: 'Unable to disable collateral functionality due to pending pledges',
    245: 'Missing/Invalid field asset',
    246: 'Invalid Blockchain',
    247: 'Blockchain Transfer withdrawal execution is not supported',
    248: 'WithdrawalType cannot be changed on an existing withdrawal instruction',
    249: 'Withdrawal instruction cannot be edited while a withdrawal using it is in progress',
    250: 'Invalid State/Province Code',
    251: 'Firm has an account with an active balance or pending transaction for this asset',
    255: 'MAX_CODE'
};

export const WORLFLOW_SUCCESS_CODE = 32;

export const doesWorkflowRejectCodeExist = (code: number): boolean => code in WorkflowRejectCodes;

export const getWorkflowRejectCodeMessage = (code: number): string => WorkflowRejectCodes[code] || '';

export default WorkflowRejectCodes;